<template>
  <div>
    <point-label
      :name="$t('pc_biz_lbl_skill_model').d('能力模型')"
      :type="type"
      class="mb24"
    >
      <span>{{ jqDetails.modelName }}</span>
    </point-label>
    <div
      v-for="skill in jqDetails.jqSkillCatalogs"
      :key="skill.id"
    >
      <div class="point-text mb5">
        {{ skill.name }}
      </div>
      <div class="flex align-items-center flex-wrap">
        <template v-for="model in skill.skillModelClassifications">
          <skill-label
            v-if="model.family === 2"
            :key="model.skillId"
            :skillModel="model"
            :disabled="defaultCheckedKeys.includes(model.skillId)"
            class="mr24 mb12"
          />
          <template v-else>
            <div v-for="skill in model.skillModelMaps">
              <skill-label
                :key="skill.skillId"
                :skillModel="skill"
                :disabled="defaultCheckedKeys.includes(skill.skillId)"
                class="mr24 mb12"
              />
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import skillLabel from './skill-label';
import pointLabel from './point-label';
import SkillLabel from './skill-label.vue';

export default {
  components: { pointLabel, skillLabel, SkillLabel },
  props: {
    isForm: Boolean,
    type: Number,
    jqDetails: {
      type: Object,
      default: () => { }
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  }
};
</script>